module.exports = __webpack_public_path__ + "static/media/montepulciano.1e47f005.jpeg";